import Backdrop from '@/features/common/components/BottomSheet/parts/Backdrop'
import Sheet from '@/features/common/components/BottomSheet/parts/Sheet'
import { FC, ReactNode } from 'react'
import { StyleProp, ViewStyle } from 'react-native'

interface BottomSheetProps {
    children: ReactNode
    showBackdrop?: boolean
    style?: StyleProp<ViewStyle>
}

const BottomSheet: FC<BottomSheetProps> = ({ children, showBackdrop, style }) => {
    return (
        <>
            {showBackdrop && <Backdrop />}
            <Sheet style={style}>{children}</Sheet>
        </>
    )
}

export default BottomSheet
